<template>
  <div class="customer-wrap">
    <email-mobile-form v-show="!userStore.token && !forceShow"
      @loginUser="loginUser" @nonUser="nonUser"
      @getUserInfo="getUserInfo" @hideVeriForm="hideVeriForm"
    />

    <customer v-show="userStore.token || forceShow"
      :user="user" :flash="flash" 
      :backLink="backLink" :showLoginBox="showLoginBox"
      ref="customer"
    />
  </div>
</template>

<script>
import customer from "./CustomerForm.vue"
import EmailMobileForm from "../Global/EmailMobileForm.vue"

export default {
  name: 'customer-wrap',
  props: [ 'user', 'flash', 'backLink', 'showLoginBox' ],
  components: { EmailMobileForm, customer },
  data () {
    return {
      forceShow: false
    }
  },
  computed: {
    userStore () { return this.$store.state.user }
  },
  methods: {
    loginUser (res) {
      if (this.$refs.customer) this.$refs.customer.loginUser(res)
      this.forceShow = false
    },
    nonUser (res) {
      if (this.$refs.customer) this.$refs.customer.nonUser(res)
      this.forceShow = true
    },
    getUserInfo (res) {
      if (this.$refs.customer) this.$refs.customer.getUserInfo(res)
    },
    hideVeriForm () {
      if (this.$refs.customer) this.$refs.customer.hideVeriForm()
    }
  }
}
</script>


// WEBPACK FOOTER //
// index.vue?1eacf1c3